// Mirrors the CSS custom properties in apps/web/src/index.css — the mobile-facing
// source of truth for the same gold/felt "snooker" visual identity. Web keeps its
// working CSS variables untouched; this is a deliberate, manually-synced duplication.
export const colors = {
  baize: '#1a4a2e',
  baizeDark: '#0f2d1c',
  baizeLight: '#236038',
  felt: '#2d6b42',
  gold: '#c9a84c',
  goldLight: '#e8c96a',
  chalk: '#f5f0e8',
  chalkDim: '#c8bfab',
  red: '#c0392b',
  white: '#ffffff',
  rail: '#5c3a1e',
  railLight: '#7a4f2a',
  shadow: 'rgba(0,0,0,0.45)',
} as const;

export type ColorToken = keyof typeof colors;
